import { useState, useEffect, cloneElement, isValidElement } from "react";
import ReactPaginate from "../components/common/ReactPaginate";

function usePagination({ itemsPerPage, data = [], children }: any) {
    const [itemOffset, setItemOffset] = useState(0);

    // Ensure data is always an array
    const items = Array.isArray(data) ? data : Object.values(data || []);

    useEffect(() => {
        // Reset pagination when data changes
        setItemOffset(0);
    }, [data]);

    const endOffset = itemOffset + itemsPerPage;
    const currentItems = items.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(items.length / itemsPerPage);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % items.length;
        setItemOffset(newOffset);
    };

    const clonedChildren =
        isValidElement(children) && cloneElement(children as any, { currentItems });

    const paginationUI = (
        <div className="cht-w-full">
            {clonedChildren}
            {pageCount > 1 && (
                <ReactPaginate
                    previousLabel="Prev"
                    nextLabel="Next"
                    breakLabel="..."
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    pageCount={pageCount}
                    marginPagesDisplayed={3}
                    containerClassName="cht-flex cht-items-center cht-justify-center cht-gap-1 sm:cht-gap-2 cht-my-10 cht-list-none cht-p-0"
                    pageClassName=""
                    pageLinkClassName="cht-w-10 cht-h-10 cht-flex cht-items-center cht-justify-center cht-rounded-xl cht-text-sm !cht-font-body cht-font-semibold cht-text-slate-600 hover:cht-bg-slate-100 hover:cht-text-[#3e57da] cht-transition-all cht-duration-200 cht-border cht-border-slate-200/80 !cht-no-underline"
                    previousClassName=""
                    previousLinkClassName="cht-px-4 cht-h-10 cht-flex cht-items-center cht-justify-center cht-rounded-xl cht-text-sm !cht-font-body cht-font-semibold cht-text-slate-600 hover:cht-bg-slate-100 hover:cht-text-[#3e57da] cht-transition-all cht-duration-200 cht-border cht-border-slate-200/80 !cht-no-underline"
                    nextClassName=""
                    nextLinkClassName="cht-px-4 cht-h-10 cht-flex cht-items-center cht-justify-center cht-rounded-xl cht-text-sm !cht-font-body cht-font-semibold cht-text-slate-600 hover:cht-bg-slate-100 hover:cht-text-[#3e57da] cht-transition-all cht-duration-200 cht-border cht-border-slate-200/80 !cht-no-underline"
                    breakClassName=""
                    breakLinkClassName="cht-w-10 cht-h-10 cht-flex cht-items-center cht-justify-center cht-text-sm cht-text-slate-400"
                    activeClassName="[&>a]:!cht-bg-[#3e57da] [&>a]:!cht-text-white [&>a]:!cht-border-[#3e57da] [&>a]:!cht-shadow-sm"
                    disabledClassName="[&>a]:!cht-opacity-40 [&>a]:!cht-pointer-events-none"
                />
            )}
        </div>
    );

    return { paginationUI };
}

export default usePagination;
